import React from 'react';
import {Header,Item, Label,  Breadcrumb, Embed, Transition, Icon, Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Quiz from 'react-quiz-component';
import moment from 'moment';


 //<Quiz quiz={quiz} showInstantFeedback={true} continueTillCorrect={true} onComplete={setQuizResult} showDefaultResult={false} customResultPage={renderCustomResultPage}/>
/*

*/


const ExamenRespuesta=({ id, ajaxCallInProgress, errores=[], strings,  quiz, setQuizResult, renderCustomResultPage})=>{

        //console.log(quiz);
   
	return (
    <div>    
        
        {quiz!=null?
         <div>
                <Header as='h3'>Respuestas del alumno - xxxxx</Header>

                    {quiz.questions.map(preguntas=>
                        <Segment attached>
                        <Header size='medium'>
                            {preguntas.question}
                        </Header>
                        <Segment.Group compact>
                        {preguntas.answers.map((respuesta, i) =>
                                    
                            <Segment >
                                {respuesta}  - 
                                    {preguntas.userInput==i+1?
                                        <Icon name="user" color={preguntas.correctAnswer==i+1?"green":"red"}/> 
                                        :
                                        ""
                                    }
                
                                    {preguntas.correctAnswer==i+1?
                                        <Icon name="checkmark" color="green"/>    
                                    :
                                    
                                        ""
                                    }
                            
                                    
                            </Segment>
                                
                        )}
                        </Segment.Group>
                  
                     </Segment>

                    )}
        </div>                        
        :

            "Cargando"

        }
    </div>    
	);
};



export default ExamenRespuesta;